type Column<T, K extends keyof T> = {
  id: K;
  [key: string]: any;
};

export function getSchemaColumns<T>(
  { columns }: { columns: Record<string, any> },
  columnMask: Record<string, any>
): Column<T, keyof T>[] {
  return Object.keys(columnMask).map((id) => ({
    ...columns[id],
    id,
  }));
}
